/*
 * View for the right side of the Topic page.  If the topic is a FAQ, it shows the response
 * preview.  If it is a conversation, it shows a read-only topic diagram
 */

define([
  "marionette",
  "modules/topicsSplit/topic/topicConversationPreview/template/topicConversationPreviewTemplate.html",
], function (Marionette, TopicConversationPreviewTemplate) {
  var TopicConversationPreviewView = {};

  TopicConversationPreviewView.topicConversationPreviewLayout = Marionette.Layout.extend({
    template: TopicConversationPreviewTemplate,
    regions: {
      previewArea: "#previewArea",
    },
  });

  return TopicConversationPreviewView;
});
